import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ChevronRight } from 'lucide-react';

// Entry point → the Living "<Pillar> District" game layer. Shown on each pillar page.
const DistrictEntryButton = ({ pillar, accent, name }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(`/district/${pillar}`)}
      data-testid={`enter-${pillar}-district-btn`}
      className="w-full group relative overflow-hidden rounded-2xl border px-5 py-4 flex items-center justify-between transition-all"
      style={{ borderColor: `${accent}4d`, background: `linear-gradient(90deg, ${accent}26 0%, ${accent}12 45%, transparent 100%)` }}
    >
      <span className="flex items-center gap-3 text-left">
        <span className="w-11 h-11 rounded-2xl grid place-items-center shrink-0 border" style={{ background: `${accent}33`, borderColor: `${accent}66` }}>
          <Sparkles className="w-5 h-5" style={{ color: accent }} />
        </span>
        <span className="leading-tight">
          <span className="block text-[10px] uppercase tracking-[0.2em]" style={{ color: accent }}>New · Living Layer</span>
          <span className="block font-secondary font-bold text-white text-base">Enter your {name} District</span>
          <span className="block text-xs text-zinc-400">Earn coins from healthy actions and build your world.</span>
        </span>
      </span>
      <ChevronRight className="w-5 h-5 shrink-0 transition-transform group-hover:translate-x-1" style={{ color: accent }} />
    </button>
  );
};

export default DistrictEntryButton;
